import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './gradient-stroke.scss';

export function GradientStroke({ className = null, withAnimation = false }) {
  return <div className={classnames('gradient-stroke', className, { 'with-animation': withAnimation })} />;
}

GradientStroke.propTypes = {
  className: PropTypes.string,
  withAnimation: PropTypes.bool,
};
